import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { makeStyles } from '@material-ui/core';

import { FingotiLoading } from '../Loading';


import './jsonColours.css';

// const useStyles = makeStyles(theme => ({
//     '@global': {
//         'code': {
//             backgroundColor: '#e0e0e0',
//             padding: '0.5em 0.5em',
//             margin: '0',
//             borderRadius: '3px',
//         },
//         'pre': {
//             backgroundColor: '#e0e0e0',
//             padding: theme.spacing(2),
//             margin: '0',
//             borderRadius: theme.spacing(1) / 2,
//         },
//         'li': {
//             lineHeight: '2'
//         }
//     }
// }))

/**
 * Renders a given markdown file as HTML
 * @param {string} path - path to MD file on CDN, this prop will include the base URL for you (e.g /dir1/mdfile.md)
 * @param {string} url - full URL to MD file, will override path if both are provided
 * @param {object} components - Object of components to override the default, refer to React-Markdown docs
 * @param {object} rest - Any other props provided will be passed to ReactMarkdown
 * @returns {JSX.Element}
 */
export const FingotiMarkdown = ({ path, url, components, ...rest }) => {

    // const classes = useStyles();
    const [isLoading, setIsLoading] = useState(true);
    const [md, setMd] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        let fetchUrl = url !== undefined ? url : `https://cdn.fingoti.com` + path;

        fetch(fetchUrl) //This didn't work: {method: "GET", mode: "no-cors"}
            .then((response) => {
                if (response.ok) return response.text();
                else return Promise.reject(response.statusText);
            })
            .then((text) => {
                setMd(text);
                setIsLoading(false);
            })
            .catch((error) => {
                setError(true);
                console.error(error);
            });

    }, [])

    return (
        <React.Fragment>
            {
                isLoading ?
                    <FingotiLoading fullHeight={false} />
                    :
                    error ?
                        <div>
                            An error has occured
                        </div>
                        :
                        <div>
                            <ReactMarkdown
                                components={components}
                                remarkPlugins={[gfm]}
                                rehypePlugins={[rehypeRaw]}
                                children={md}
                                {...rest}
                            />
                        </div>
            }
        </React.Fragment>
    )
}
